import {
   ADD_WHITELABELS,
  ADD_WHITELABELS_SUCCESS,
  ADD_WHITELABELS_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  whitelabelData: [],
};

const whitelabelReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case ADD_WHITELABELS:
      return { ...state, loading: true };
    case ADD_WHITELABELS_SUCCESS:
      return {
        ...state,
        whitelabelData: action?.payload,
        loading: false,
      };
    case ADD_WHITELABELS_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default whitelabelReducer;
